import { CSSProperties } from 'react'
import * as RadixTooltip from '@radix-ui/react-tooltip'

import { QuestionIcon } from './QuestionIcon'
import Tooltip from './Tooltip'

export default function HelpWithTooltip({
  tooltipContent,
  wrapperStyle,
  arrowHidden = false,
  size,
  fontSize,
  ...contentProps
}: {
  fontSize?: string
  size?: string
  arrowHidden?: boolean
  tooltipContent: JSX.Element | string
  wrapperStyle?: CSSProperties
} & RadixTooltip.TooltipContentProps) {
  return (
    <Tooltip
      {...contentProps}
      arrowHidden={arrowHidden}
      wrapperStyle={wrapperStyle}
      tooltipContent={tooltipContent}
    >
      <QuestionIcon type="button" size={size} fontSize={fontSize}>
        ?
      </QuestionIcon>
    </Tooltip>
  )
}
